import React, { createContext, useEffect, useMemo } from 'react';
import { AUTH_STORAGE_KEYS } from './authShared';
import { authStore } from './authStore';

export const AuthContext = createContext(authStore);

const STORAGE_KEYS = new Set([
  AUTH_STORAGE_KEYS.accessToken,
  AUTH_STORAGE_KEYS.refreshToken,
  AUTH_STORAGE_KEYS.userNo,
  AUTH_STORAGE_KEYS.userNoLegacy,
  AUTH_STORAGE_KEYS.isAdmin,
]);

export function AuthProvider({ children }) {
  useEffect(() => {
    const initialSnapshot = authStore.bootstrap();
    if (initialSnapshot.accessToken) {
      void authStore.verifySession();
    }

    const handleStorage = (event) => {
      if (event.key === null || STORAGE_KEYS.has(event.key)) {
        authStore.hydrateFromStorage('storage');
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && authStore.getSnapshot().accessToken) {
        void authStore.verifySession();
      }
    };

    window.addEventListener('storage', handleStorage);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('storage', handleStorage);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  const value = useMemo(() => authStore, []);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
